var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{attrs:{"content":_vm.unreadMessageCount,"value":_vm.unreadMessageCount,"color":"red","overlap":""}},[_c('v-icon',{attrs:{"size":_vm.size}},[_vm._v("mdi-message-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }